import React from 'react';
import { Link } from 'react-router-dom';
import View from "../components/three/Scene3D/View";

function Layout(props) {

  const miniTitleAbout = () => {
    const viewTitle = document.getElementById("aboutTitle");
    viewTitle.style.display = "block";
  };
  const hideMiniTitleAbout = () => {
    const viewTitle = document.getElementById("aboutTitle");
    viewTitle.style.display = "none";
  };

  const miniTitlePorfolio = () => {
    const viewTitle = document.getElementById("porfolioTitle");
    viewTitle.style.display = "block";
  };
  const hideMiniTitlePorfolio = () => {
    const viewTitle = document.getElementById("porfolioTitle");
    viewTitle.style.display = "none";
  };

  const miniTitleContact = () => {
    const viewTitle = document.getElementById("contactTitle");
    viewTitle.style.display = "block";
  };
  const hideMiniTitleContact = () => {
    const viewTitle = document.getElementById("contactTitle");
    viewTitle.style.display = "none";
  };




  return (
    <React.Fragment>
      <View />

      <div className="view-nav">
        <nav>
          <ul>
            <li><Link to="/porfolio" className="Link" onMouseOver={miniTitlePorfolio} onMouseOut={hideMiniTitlePorfolio}> <div id='porfolioTitle'><p className='porfolioTitle'>Proyects</p> <div className='porfolioCloud'></div>  </div> <div className='navIcon'> <div className='folder'> <p className='dev'>DEV</p></div>  <div className='folder-open'> </div></div> </Link></li>
            <li><Link to="/porfolio-v3.0" className="Link" onMouseOver={miniTitleAbout} onMouseOut={hideMiniTitleAbout}> <div id='aboutTitle'><p className='aboutTitle'>About me</p> <div className='cloud'></div>  </div>  <div className='navIcon'> <div className='head'></div> <div className='bodyIcon'></div> <div className='whiteSquare'></div> </div></Link></li>
            <li> <a href="https://www.linkedin.com/in/jamesgrimaldo/" target="_blank" rel="noopener noreferrer" onMouseOver={miniTitleContact} onMouseOut={hideMiniTitleContact}> <div id='contactTitle'> <p className='contactTitle'>Contact</p> <div className='contactCloud'></div>  </div>  <div className='navIcon'> <p className='in'>in</p> </div> </a></li>
          </ul>
        </nav>
      </div>


      {props.children}

      <footer>
        <p>Dev Grimaldo 2022</p>
      </footer>
    </React.Fragment>
  );
}
export default Layout;